































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover } from 'element-ui';
import { setDateTimeStamp } from '@acgn/herm/src/util/time';
import { namespace } from 'vuex-class';
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    [Popover.name]: Popover
  }
})

/**
 * 任务名称鼠标经过组件
 */
export default class AcgnPopoverDetail extends Vue {
  @Prop() private row: any;
  @Prop() private column: any;
  @CommGetter private attributeData: any; // 公共类型
  private setDateTimeStamp(date: any) {
    return setDateTimeStamp(date, 'YYYY-MM-DD HH:mm:ss');
  }

  // 审批状态样式
  private getStaClass(status: any) {
    switch (status) {
      case 1:
        return 'acgn-succ';
      case 2:
        return 'acgn-ing';
      case 3:
        return 'acgn-refuse';
      case 4:
        return 'acgn-pass';
      case 5:
        return 'acgn-succ';
    }
  }

  // 逾期 审批
  private get statusOverdue() {
    return this.attributeData.other_type[1][1].name;
  }

  // 逾期 提交
  private get statusSubmit() {
    return this.attributeData.other_type[2][1].name;
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[0];
  }

  // 审批状态名称
  private getStaName(status: any) {
    return this.statusName[status - 1].name;
  }

  // 审批状态列表
  private get statusNameUser() {
    return this.attributeData.other_type[9];
  }

  // 审批节点状态
  private getAppSta(sta: any) {
    return this.statusNameUser[sta - 1].name;
  }
}
